function sendSubscriptionToServer(subscription) {
  if (window.Livewire.currentUser) {
    const subscriptionJSON = subscription.toJSON();

    fetch('/api/v1/user/set_vapid_attributes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        vapid_endpoint: subscriptionJSON.endpoint,
        vapid_auth: subscriptionJSON.keys.auth,
        vapid_p256dh: subscriptionJSON.keys.p256dh,
      }),
    });
  }
}

function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service_worker.js', { scope: './' });

    navigator.serviceWorker.ready.then(registration => {
      if (window.Livewire.vapidPublicKey) {
        registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: window.Livewire.vapidPublicKey,
        }).then(subscription => {
          sendSubscriptionToServer(subscription);
        });
      }
    });
  }
}

if ('Notification' in window) {
  if (Notification.permission === 'granted') {
    registerServiceWorker();
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        registerServiceWorker();
      }
    });
  }
}
